import React from 'react'
import styled from 'styled-components'
import { DeleteOutline } from '@material-ui/icons'

import { Spacings, Text } from '@styles'

import Button from '../../basic/Button'
import Pill from '../../basic/Pill'

const CardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_3B};
	padding: ${Spacings.SPACING_4B};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.lg};
	background: ${({ theme }) => theme.colors.surface.card};
`

const TopRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_2B};
`

const Actions = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_2B};
`

const NameRow = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_2B};
`

const Name = styled.span`
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_700};
	color: ${({ theme }) => theme.colors.text.primary};
`

const TradeNameChip = styled.div`
	display: inline-flex;
	align-items: center;
	gap: ${Spacings.SPACING_1B};
	width: fit-content;
	padding: ${Spacings.SPACING_1B} ${Spacings.SPACING_2B};
	border-radius: ${({ theme }) => theme.radius.sm};
	background: ${({ theme }) => theme.colors.surface.sunken};
	font-size: ${Text.TINY_SMALL};
	color: ${({ theme }) => theme.colors.text.primary};

	b {
		color: ${({ theme }) => theme.colors.text.secondary};
		font-weight: ${Text.BOLD_600};
	}
`

const AddressText = styled.p`
	margin: 0;
	font-size: ${Text.BASE_SMALL};
	line-height: 1.5;
	color: ${({ theme }) => theme.colors.text.secondary};
`

const CityText = styled(AddressText)`
	margin-top: ${Spacings.SPACING_2};
	font-size: ${Text.TINY_SMALL};
	font-weight: ${Text.BOLD_600};
`

const AddressBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};
`

const GstCard = ({ data, onEdit, onDelete, disabled }) => {
	const address = data?.address
	const cityLine = address ? `${address?.city}, ${address?.state} - ${address?.pincode}` : ''

	return (
		<CardWrapper>
			<TopRow>
				<Pill size='small' color='info' round>{`GST Number : ${data?.gst}`}</Pill>
				<Actions>
					<Button type='button' variant='ghost' color='danger' size='medium' onClick={onDelete} disabled={disabled} aria-label='Delete GST'>
						<DeleteOutline />
					</Button>
				</Actions>
			</TopRow>

			<NameRow>
				<Name>{data?.legal_name ?? '--'}</Name>
				{data?.status && (
					<Pill color='success' round size='small'>
						{data?.status}
					</Pill>
				)}
			</NameRow>

			{data?.trade_name && (
				<TradeNameChip>
					<b>Trade Name:</b>
					{data?.trade_name}
				</TradeNameChip>
			)}

			<AddressBlock>
				{address?.complete_address && <AddressText>{address?.complete_address}</AddressText>}
				{cityLine && <CityText>{cityLine}</CityText>}
			</AddressBlock>
		</CardWrapper>
	)
}

export default GstCard
